// Enriquece visualmente el selector nativo de variantes SOLO en la
// Lámpara Solar Exterior 150W (comprobado por data-product-handle) para
// que las 3 opciones (1 lámpara / Pack de 2 / Pack de 3) se vean como
// tarjetas con detalle, precio, ahorro, insignia y el regalo de cada
// una — sin tocar el mecanismo real de Shopify (son variantes de
// verdad, con su propio precio), así que el número que se ve aquí es
// el mismo que cobra el carrito y el checkout.
//
// OJO 1: Dawn (product-info.js) REEMPLAZA por completo el elemento
// <variant-selects> cada vez que el cliente elige una opción (trae la
// versión "de fábrica" del servidor, sin nuestras tarjetas). Por eso
// esto no corre una sola vez: un MutationObserver vuelve a aplicar el
// diseño cada vez que Shopify reconstruye el selector.
//
// OJO 2: antes se forzaba "Pack de 2" al cargar; ya no. Shopify
// preselecciona la PRIMERA variante (1 lámpara) y así se queda hasta que
// el cliente elija otra (DEFAULT_ELEGIDO vacío = no se fuerza nada).
(function () {
  var HANDLE = 'lampara-solar-led-para-exterior-150w-control-remoto-y-sensor-de-radar';

  var datos = {
    '1 lámpara': {
      detalle: 'Una zona',
      precio: '$1,499.00',
      antes: '$2,299.00',
      ahorro: 'Ahorras $800',
    },
    'Pack de 2': {
      detalle: 'Cobertura doble',
      precio: '$2,719.00',
      antes: '$2,998.00',
      ahorro: '$1,359.50 c/u · Ahorras $279',
      badge: '⭐ MÁS VENDIDO',
      regalo: '🎁 + Lámpara de Pared LED Cúbica 12W GRATIS',
      regaloImagen: 'https://cdn.shopify.com/s/files/1/1043/8587/2155/files/D_NQ_NP_2X_906615-MLM83518584348_042025-F.webp?width=900',
      regaloAlt: 'Lámpara de Pared LED Cúbica 12W — Luz Ascendente y Descendente',
    },
    'Pack de 3': {
      detalle: 'Exterior completo',
      precio: '$3,809.00',
      antes: '$4,497.00',
      ahorro: '$1,269.67 c/u · Ahorras $688',
      regalo: '🎁 + Set de 10 luces solares de jardín GRATIS',
      regaloImagen: 'https://cdn.shopify.com/s/files/1/1043/8587/2155/files/D_NQ_NP_2X_642294-MLA92743263367_092025-F.webp?width=900',
      regaloAlt: 'Set de 10 Luces Solares LED para Jardín — Diseño Espeto',
    },
  };

  // Ya no se fuerza ninguna opción al cargar: se queda la primera (1 lámpara)
  // y solo cambia si el cliente elige otra o si el link trae ?variant=.
  var DEFAULT_ELEGIDO = '';
  var yaForzoDefault = false;

  function crearSpan(clase, texto) {
    var span = document.createElement('span');
    span.className = clase;
    span.textContent = texto;
    return span;
  }

  function actualizarNotaRegalo(contenedor) {
    var fila = contenedor.querySelector('.tz-pack-nota__regalo-fila');
    var notaRegalo = contenedor.querySelector('.tz-pack-nota__regalo');
    var fotoWrap = contenedor.querySelector('.tz-pack-nota__foto-wrap');
    var foto = contenedor.querySelector('.tz-pack-nota__foto');
    var fotoGrande = contenedor.querySelector('.tz-pack-nota__foto-grande');
    if (!notaRegalo) return;
    var marcado = contenedor.querySelector('input[type="radio"]:checked');
    var valor = marcado ? marcado.value.replace(/\s+/g, ' ').trim() : '';
    var info = datos[valor];
    if (fila) fila.hidden = !(info && info.regalo);
    if (info && info.regalo) {
      notaRegalo.textContent = info.regalo;
      notaRegalo.hidden = false;
    } else {
      notaRegalo.hidden = true;
    }
    if (fotoWrap && foto && fotoGrande) {
      if (info && info.regaloImagen) {
        foto.src = info.regaloImagen;
        foto.alt = info.regaloAlt || '';
        fotoGrande.src = info.regaloImagen;
        fotoGrande.alt = info.regaloAlt || '';
        fotoWrap.hidden = false;
      } else {
        fotoWrap.hidden = true;
        foto.removeAttribute('src');
        fotoGrande.removeAttribute('src');
      }
    }
  }

  function forzarDefaultSiHaceFalta(contenedor) {
    if (yaForzoDefault || !DEFAULT_ELEGIDO) return;
    if (location.search.indexOf('variant=') !== -1) {
      yaForzoDefault = true; // el link ya trae una variante explícita, no tocar
      return;
    }
    var radios = contenedor.querySelectorAll('input[type="radio"]');
    var objetivo = null;
    radios.forEach(function (radio) {
      if (radio.value.replace(/\s+/g, ' ').trim() === DEFAULT_ELEGIDO) objetivo = radio;
    });
    if (!objetivo) return;
    yaForzoDefault = true;
    if (!objetivo.checked) {
      objetivo.checked = true;
      // Dawn reacciona a este 'change' como si fuera un clic real: entre
      // otras cosas, intenta centrar la galería de medios en la imagen de
      // la variante (window.scrollTo) y, después de volver a pedir el
      // precio/botón por AJAX, le devuelve el foco al radio con
      // elemento.focus() — y el foco nativo del navegador también hace
      // scroll solo si el elemento no está a la vista. Como esto pasa
      // justo al cargar la página (nadie pidió ver otra imagen ni tocó
      // nada todavía), se anulan ambos por un momento para que la
      // selección automática del Pack de 2 no se sienta como "la página
      // se jala sola".
      var scrollToOriginal = window.scrollTo;
      var focusOriginal = HTMLElement.prototype.focus;
      window.scrollTo = function () {};
      HTMLElement.prototype.focus = function (opciones) {
        return focusOriginal.call(this, Object.assign({}, opciones, { preventScroll: true }));
      };
      objetivo.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(function () {
        window.scrollTo = scrollToOriginal;
        HTMLElement.prototype.focus = focusOriginal;
      }, 2500);
    }
  }

  function mejorar(contenedor) {
    contenedor.querySelectorAll('.product-form__input--pill label').forEach(function (label) {
      if (label.classList.contains('tz-pack-tarjeta')) return; // ya mejorada en esta pasada

      var primerNodo = label.childNodes[0];
      var texto = primerNodo ? primerNodo.textContent.replace(/\s+/g, ' ').trim() : '';
      var info = datos[texto];
      if (!info) return;

      var etiquetaAgotado = label.querySelector('.label-unavailable');
      label.textContent = '';
      label.classList.add('tz-pack-tarjeta');

      if (info.badge) {
        label.appendChild(crearSpan('tz-pack-tarjeta__badge', info.badge));
      }
      label.appendChild(crearSpan('tz-pack-tarjeta__titulo', texto));
      label.appendChild(crearSpan('tz-pack-tarjeta__detalle', info.detalle));
      if (info.ahorro) {
        label.appendChild(crearSpan('tz-pack-tarjeta__ahorro', info.ahorro));
      }

      var precioWrap = document.createElement('span');
      precioWrap.className = 'tz-pack-tarjeta__precio';
      if (info.antes) {
        var antes = document.createElement('s');
        antes.className = 'tz-pack-tarjeta__antes';
        antes.textContent = info.antes;
        precioWrap.appendChild(antes);
        precioWrap.appendChild(document.createTextNode(' '));
      }
      precioWrap.appendChild(document.createTextNode(info.precio));
      label.appendChild(precioWrap);
      if (etiquetaAgotado) label.appendChild(etiquetaAgotado);
    });

    var fieldset = contenedor.querySelector('fieldset');
    if (fieldset && !contenedor.querySelector('.tz-pack-nota')) {
      var nota = document.createElement('div');
      nota.className = 'tz-pack-nota';
      nota.innerHTML =
        '<p class="tz-pack-nota__envio">🚚 Envío gratis en todas las opciones</p>' +
        '<div class="tz-pack-nota__regalo-fila">' +
        '<span class="tz-pack-nota__foto-wrap" tabindex="0" hidden>' +
        '<img class="tz-pack-nota__foto" loading="lazy" width="56" height="56" alt="">' +
        '<img class="tz-pack-nota__foto-grande" loading="lazy" alt="" aria-hidden="true">' +
        '</span>' +
        '<p class="tz-pack-nota__regalo" hidden></p>' +
        '</div>';
      fieldset.insertAdjacentElement('afterend', nota);
      contenedor.addEventListener('change', function () {
        actualizarNotaRegalo(contenedor);
      });
    }

    actualizarNotaRegalo(contenedor);
    forzarDefaultSiHaceFalta(contenedor);
  }

  function buscarYMejorar() {
    var contenedor = document.querySelector('variant-selects[data-product-handle="' + HANDLE + '"]');
    if (contenedor) mejorar(contenedor);
  }

  buscarYMejorar();

  var raiz = document.querySelector('.product') || document.body;
  var observando = false;
  var observer = new MutationObserver(function () {
    if (observando) return;
    observando = true;
    // requestAnimationFrame: espera a que Dawn termine de insertar el
    // nuevo <variant-selects> antes de volver a decorarlo.
    requestAnimationFrame(function () {
      buscarYMejorar();
      observando = false;
    });
  });
  observer.observe(raiz, { childList: true, subtree: true });

  // Acercar la miniatura del regalo: al presionarla (o pasar el mouse)
  // se ve más grande justo encima, sin abrir nada a pantalla completa.
  // Delegado en document porque la miniatura se vuelve a crear cada vez
  // que Shopify reconstruye el selector.
  var activarZoom = function (evento) {
    var envoltura = evento.target.closest('.tz-pack-nota__foto-wrap');
    if (envoltura) envoltura.classList.add('is-activo');
  };
  var desactivarZoom = function (evento) {
    var envoltura = evento.target.closest('.tz-pack-nota__foto-wrap');
    if (envoltura) envoltura.classList.remove('is-activo');
  };
  document.addEventListener('mousedown', activarZoom);
  document.addEventListener('touchstart', activarZoom, { passive: true });
  document.addEventListener('mouseup', desactivarZoom);
  document.addEventListener('mouseleave', desactivarZoom, true);
  document.addEventListener('touchend', desactivarZoom);
  document.addEventListener('touchcancel', desactivarZoom);
})();
